import React from 'react';
import { formatCurrency } from '../../components/formatters';

const CompareField = ({title, modifiedValue, unmodifiedValue, type, mask}) => {
    if(type === "currency"){
        if(modifiedValue)
        modifiedValue = formatCurrency(modifiedValue,2);
        if(unmodifiedValue)
        unmodifiedValue = formatCurrency(unmodifiedValue,2);
    }
    return ( 
        <>
        {title ?
        <div className="mb-2">
        <label className="text-xs">{title}</label>
        {
            mask ? <>Not Shown</> : <>
             {modifiedValue === unmodifiedValue ?
            <p className=''>{modifiedValue}</p>
            :
            <p>
                <span className="line-through">{unmodifiedValue}</span> <span className="text-purple">{modifiedValue}</span>
            </p>
        }</>
        }
        </div>    
        :
        <>
        {
            mask ? <>Not Shown</> : <>
            {
            modifiedValue === unmodifiedValue ?
            <>{modifiedValue}</>
            :
            <>
                <span className="line-through">{unmodifiedValue}</span> <span className="text-purple">{modifiedValue}</span>
            </>
            }        
        </>
         }</>
        }
        </>
    );
}
 
export default CompareField;